/*
*
* File JS Principale
*
*/
// IMPORT JQUERY
//--------------------------------------------------------------------//

import $ from 'jquery';


// IMPORT SCSS PER LA COMPILAZIONE
//--------------------------------------------------------------------//

import 'scss/app.scss';

//--------------------------------------------------------------------//

// Carichiamo i font in maniera asincrona
//--------------------------------------------------------------------//

var Webfont = require('webfontloader');

Webfont.load({
    typekit: {
        id: 'xql0vbc',
    }
});

//--------------------------------------------------------------------//

// Libreria Lazysizes
//--------------------------------------------------------------------//
import 'lazysizes';

//--------------------------------------------------------------------//

// Import Utilies
//--------------------------------------------------------------------//

import { initSvgImage } from './utilities/img-svg';
import smoothScroll from './utilities/smooth-scroll';
import initAnimations from './utilities/animations';

//--------------------------------------------------------------------//


// Init Utilies
//--------------------------------------------------------------------//

initSvgImage();

smoothScroll();

initAnimations();

//--------------------------------------------------------------------//


// Import Componenti
//--------------------------------------------------------------------//

import languageList from 'components/language-list/language-list';

import initHeader from 'components/header/header';

import blockSponsor from 'components/block-sponsor/block-sponsor';

import footer from 'components/footer/footer';

import bannerNewsletter from 'components/banner-newsletter/banner-newsletter';

import accordion from 'imComponents/accordion/accordion';

import modalCookie from 'imComponents/modal-cookie/modal-cookie';


//--------------------------------------------------------------------//


// Init Componenti
//--------------------------------------------------------------------//

blockSponsor();

initHeader();

accordion();

modalCookie();

//--------------------------------------------------------------------//